import { OnInit, Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-produtct-characteristcs',
  templateUrl: './product-characteristics.component.html',
  styleUrls: ['./product-characteristics.component.scss']
})
export class ProductCharacteristicsComponent implements OnInit {

  public titleProperties = 'Detalhes do imóvel';
  public titleCondominium = 'Detalhes do condomínio';

  public listProperties = [
    {
      id: '1',
      label: 'Aceita animais',
      field: 'aceita'
    },
    {
      id: '2',
      label: 'Lavabo',
      field: 'lavabo'
    },
    {
      id: '3',
      label: 'Quintal',
      field: 'quintal'
    },
    {
      id: '4',
      label: 'Mobiliado',
      field: 'mobiliado'
    },
    {
      id: '5',
      label: 'Tem geladeira',
      field: 'geladeira'
    },
    {
      id: '6',
      label: 'Churrasqueira',
      field: 'churras'
    },
    {
      id: '7',
      label: 'Dependências de empregado',
      field: 'empregado'
    },
    {
      id: '8',
      label: 'Cozinha americana',
      field: 'cozinha'
    },
    {
      id: '9',
      label: 'Ar condicionado',
      field: 'condicionado'
    },
    {
      id: '10',
      label: 'Tem fogão',
      field: 'fogao'
    }
  ];

  public listCondominium = [
    {
      id: '1',
      label: 'Portaria 24h',
      field: ''
    },
    {
      id: '2',
      label: 'Portaria diurna',
      field: ''
    },
    {
      id: '3',
      label: 'Portaria noturna',
      field: ''
    },
    {
      id: '4',
      label: 'Academia',
      field: ''
    },
    {
      id: '5',
      label: 'Elevador',
      field: ''
    },
    {
      id: '6',
      label: 'Área verde',
      field: ''
    },
    {
      id: '7',
      label: 'Lavanderia',
      field: ''
    },
    {
      id: '8',
      label: 'Playground',
      field: ''
    }
  ];

  public tags = [{value: 'Telefone', id: 0}, {value: 'E-mail', id: 1}, {value: 'WhatsApp', id: 2}];
  public options = [{value: 'Telefone', id: 0}, {value: 'E-mail', id: 1}, {value: 'WhatsApp', id: 2}, {value: 'Chat', id: 3}];

  public tagsCondominiun = [{value: 'Telefone', id: 0}, {value: 'E-mail', id: 1}, {value: 'WhatsApp', id: 2}];
  public optionsCondominiun = [{value: 'Telefone', id: 0}, {value: 'E-mail', id: 1}, {value: 'WhatsApp', id: 2}, {value: 'Chat', id: 3}];


  public form: FormGroup;
  public formGorup = {};

  ngOnInit(): void {
    this.initializeForm();
  }

  private initializeForm() {
    this.listProperties.forEach(x => this.formGorup[x.field] = new FormControl());
    this.form = new FormGroup(this.formGorup);
  }

  selectItem(data) {
  }

}
